module.exports = __webpack_public_path__ + "img/logo3.698b1907.png";